"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneModelObject = void 0;
/**
 * clone a model object
 *
 * @param {T} obj
 * @returns {T}
 */
function cloneModelObject(obj) {
    // create an empty object with the same prototype of the original object
    // then copy the fields from the original object to the new object
    return Object.assign(Object.create(Object.getPrototypeOf(obj)), obj);
}
exports.cloneModelObject = cloneModelObject;
//# sourceMappingURL=cloneModelObject.js.map